import { Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
    let navigate = useNavigate(); //for navigation

    const dashboard = () => {
        navigate('/dashboard');
    };
    return (
        <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh' }}>
            <Grid item xs={3}>
                <h1>
                    Page Not Found !!!<br></br>
                    <br></br>
                    Error 404 !!!
                </h1>
                <Button variant="contained" onClick={dashboard}>
                    Go to Dashboard
                </Button>
            </Grid>
        </Grid>
    );
};

export default PageNotFound;
